import { mapState } from "vuex";
export const bookingIndexMixins = {
  computed: {
    bookingTopBarList() {
        let topbarList = [
          {
            name: "预约列表",
            isActive: false,
            path: "/booking/list",
            icon:require("@/assets/img/menuIcons/icon-booking.png")
          },
          {
            name: "预约看板",
            isActive: false,
            path: "/booking/board",
            icon:require("@/assets/img/menuIcons/icon-booking.png")
          },
        ];
        topbarList.forEach((val) => {
          if (val.path == this.$route.path) {
            val.isActive = true;
          }
          if (val.childrenPath) {
            if (~val.childrenPath.indexOf(this.$route.path)) {
              val.isActive = true;
            }
          }
        });
        return topbarList;
      },
  },
}
